import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import {withCommon} from '../../../components/HOCs';
import {LLElementTypeSetter} from '../../../components';
import isDevMode from '../../../common/utils/is-devmode';


const LicenseIcons = withCommon({
    store: ({store}) => ({
        closeDrawer: store.drawer.close,
        setModal: store.modal.setModal,
        language: store.user.language,
        siteName: store.site.siteName,
        modifiedConfig: store.modifiedConfig,
    }),
    propTypes: {
        classSuffix: PropTypes.string,
        closeDrawer: PropTypes.func,
        licenseIcons: PropTypes.arrayOf(PropTypes.object).isRequired,
        setModal: PropTypes.func.isRequired,
        language: PropTypes.string.isRequired,
        siteName: PropTypes.string.isRequired,
    },
    isObserver: true,
})(({classSuffix = '', closeDrawer, licenseIcons, setModal, language, siteName, modifiedConfig}) => {
    const openModal = (link, customClasses) => {
        setModal({
            active: true,
            externalLink: link,
            currentKey: 'external-link',
            showFullscreenButton: true,
            customClasses: `external-link ${customClasses}`,
            showCloseButton: true,
        });
    };

    const [sealId] = useState(licenseIcons.find((iconProps) => iconProps.sealId)?.sealId || null)

    useEffect(() => {
        let script;
        // The license seal script isn't served in dev (returns index.html),
        // which throws "Unexpected token '<'"; skip it locally.
        if (sealId && !isDevMode()) {
            try {
                script = document.createElement('script');
                script.id = 'script-license';
                script.async = true;
                script.src = '/license-embedded.js';
                document.body.appendChild(script);
            } catch (e) {}
        }
        return () => {
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <div className="ll-license-icons">
            {licenseIcons.map((iconProps, i) => {
                if (
                    iconProps.elementAttributes?.href &&
                    typeof iconProps.elementAttributes?.href === 'object' &&
                    iconProps.needLang
                ) {
                    iconProps.elementAttributes.href =
                        iconProps.elementAttributes.href[language];
                }
                return (iconProps.sealId ?
                        siteName === 'Betaestas' ?
                            <div key={i} className="ll-license-curacao">
                                <div id={`ceg-${iconProps.sealId}`} data-ceg-seal-id={iconProps.sealId}
                                     data-ceg-image-size="128" data-ceg-image-type="basic-small"
                                />
                                <a href="https://verification.curacao-egaming.com/validateview.aspx?domain=betaestas.com"
                                   target="_blank" rel="noreferrer"
                                >
                                    <img
                                        src="https://verification.curacao-egaming.com/validate.ashx?domain=betaestas.com"
                                        alt="license"
                                    />
                                </a>
                            </div>
                            :
                            <div
                                key={i}
                                id={`anj-${iconProps.sealId}`}
                                data-anj-seal-id={iconProps.sealId}
                                data-anj-image-size="35"
                                data-anj-image-type="basic-small"
                            />
                        :
                        <LLElementTypeSetter
                            className="ll-license-icons__link"
                            key={i}
                            onClick={() => {
                                closeDrawer();
                                iconProps.modalLink &&
                                openModal(
                                    iconProps.modalLink
                                        ? iconProps.needLang
                                            ? iconProps.modalLink[language]
                                            : iconProps.modalLink
                                        : null,
                                    iconProps.customClasses ?? null
                                );
                            }}
                            {...iconProps.elementAttributes}
                        >
                            <i
                                className={`${iconProps.icon}-icon ll-license-icons__icon${classSuffix}`}
                            />
                        </LLElementTypeSetter>
                );
            })}
        </div>
    );
});

export default LicenseIcons;
